import {axios} from "~/plugins/axios";

const getDefaultState_ByDays = () => {
  return {
    items: [],
  }
}
const state = getDefaultState_ByDays();

const getters = {
  byDays: state => state.items,
}

const actions = {
  async loadByDaysItems({commit}, payload) {
    commit('shared/SET_LOADING', true, {root: true})
    let headers = {}
    try {
      if (payload.excel === true) {
        headers = {
          responseType: "blob",
        }
      }

      let resp = await axios.post('/api/reports/by-days', payload, headers)

      if (payload.excel === true) {
        this._vm.utils.downloadXlsx(resp)
      }

      commit('shared/SET_LOADING', false, {root: true})
      return resp.data

    } catch (err) {
      commit('shared/SET_ERROR', err.response.data, {root: true})
      commit('shared/SET_LOADING', false, {root: true})

      throw err
    }
  },
}

const mutations = {
  SET_ITEMS(state, items) {
    state.items = items;
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
